import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page Not Found | GOOD RIDES LA";
    // Signal to crawlers that this route should not be indexed.
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
          Page Not Found
        </h2>
        <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-md">
          The page you&rsquo;re looking for doesn&rsquo;t exist, but your ride
          in Los Angeles is just a click away.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-4-line" />
            <span>Back to Home</span>
          </Link>
          <Link
            to="/#reservation"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-200/70 text-foreground-800 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-calendar-check-line" />
            <span>Book a Ride</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
